import { listPointPresets, PointPresetTypeEnum } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

export type PointsChipOption = { id: string; label: string }

export type UseRecognitionPointPresetsResult = {
  points: PointsChipOption[]
  allowCustomPoints: boolean
  isLoadingPresets: boolean
}

export function useRecognitionPointPresets(): UseRecognitionPointPresetsResult {
  const { data: pointPresetsData, isLoading: isLoadingPresets } = useQuery({
    queryKey: ['pointPresets', 'recognition'],
    queryFn: () => listPointPresets({ typeIn: [PointPresetTypeEnum.RECOGNITION] }),
  })

  const recognitionPreset = pointPresetsData?.find(
    preset => preset.type === PointPresetTypeEnum.RECOGNITION,
  )

  const points: PointsChipOption[] = useMemo(() => {
    if (!recognitionPreset?.presetPoints) return []

    return [0, ...recognitionPreset.presetPoints]
      .sort((a, b) => a - b)
      .map(value => ({
        id: value.toString(),
        label: value.toString(),
      }))
  }, [recognitionPreset?.presetPoints])

  const allowCustomPoints = recognitionPreset?.allowCustomPoints ?? true

  return {
    points,
    allowCustomPoints,
    isLoadingPresets,
  }
}

export default useRecognitionPointPresets
